import React from 'react';
import PropTypes from 'prop-types';
import classes from './NavC.module.scss';

const NavC = (props) => {
  const {
    header, subHeader, nodes,
  } = props;

  return (
    <div className={classes.wrapper}>
      {header && <h4
        className={classes.header}
        dangerouslySetInnerHTML={{ __html: header }}
      />}
      {subHeader &&
      <h5
        className={classes.subHeader}
        dangerouslySetInnerHTML={{ __html: subHeader }}
      />}
      {(header || subHeader) &&
      <hr
        className={classes.seperator}
      />}
      {nodes && nodes.length > 0 &&
      <ul
        className={classes.list}
      >
        {nodes.map((node, index) => (
          <li key={index}>
            <a aria-label={node.title} href={node.url} target={node.linkTarget}>
              <span dangerouslySetInnerHTML={{ __html: node.title }} />
            </a>
          </li>
        ))}
      </ul>}
    </div>
  );
};

NavC.propTypes = {
  /**
   * Text displays at the top of the component
  */
  header: PropTypes.string,
  /**
   * Text displays directly below the header
  */
  subHeader: PropTypes.string,
  /**
   * A list of links that display directly below the header
  */
  nodes: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    linkTarget: PropTypes.string,
    title: PropTypes.string,
  })),
};

export default NavC;
